import { render, staticRenderFns } from "./SelfTestPelletizingEdit.vue?vue&type=template&id=2f94732c&"
import script from "./SelfTestPelletizingEdit.vue?vue&type=script&lang=js&"
export * from "./SelfTestPelletizingEdit.vue?vue&type=script&lang=js&"
import style0 from "./SelfTestPelletizingEdit.vue?vue&type=style&index=0&id=2f94732c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports